<script lang="ts">
	import { ThinArrow } from '@icons';
	import type { ShowingType } from '$lib/types/Showings';
	import { DateFormats, Breakpoints } from '@tools';
	import { Genres } from '$lib/Globals';

	let {
		events,
		month,
		onClick
	}: {
		events: (ShowingType & { numOfShows: number })[];
		month: Date;
		onClick?: (genre: { id: string; slug: string }, date: Date) => void;
	} = $props();
</script>

{#if Breakpoints.sm}
	<div class="container">
		<h4 class="month text:h4">Gratis i {DateFormats.monthName(month)}</h4>
		<div class="events">
			{#each events as event}
				<a class="event" href={event.path}>
					<div class="title">{event.title}</div>
					<div class="date">
						{DateFormats.dateWithWeekday(event.date)}
						{#if event.numOfShows > 1}
							+ flere
						{/if}
					</div>
				</a>
			{/each}
		</div>
		<button
			class="link"
			onclick={() => {
				if (onClick)
					onClick(
						{
							id: Genres.FREE_GENRE_ID,
							slug: 'gratis'
						},
						month
					);
			}}
		>
			<div class="button:round">
				<ThinArrow />
			</div>
		</button>
	</div>
{:else}
	<button
		class="container"
		onclick={() => {
			if (onClick)
				onClick(
					{
						id: Genres.FREE_GENRE_ID,
						slug: 'gratis'
					},
					month
				);
		}}
	>
		<h4 class="month text:h4">Gratis i {DateFormats.monthName(month)}</h4>
		<div class="link">
			<div class="button:round">
				<ThinArrow />
			</div>
		</div>
	</button>
{/if}

<style lang="scss">
	.container {
		position: relative;
		display: flex;
		flex-direction: column;
		background-color: var(--theme-primary);
		color: var(--theme-foreground);
		padding: $gap3;
		min-width: 0;
		max-width: 100%;

		@include sm {
			padding: 0;
			aspect-ratio: 1 / #{$ratio2};
		}
	}

	.month {
		max-width: 7em;

		@include sm {
			max-width: unset;
			padding: $gap5;
			padding-bottom: $gap4;
		}
	}

	.events {
		width: 100%;
		flex: 1 1 0;
		overflow: hidden;
		display: none;
		flex-direction: column;
		align-items: stretch;

		@include sm {
			display: flex;
		}
	}

	.event {
		position: relative;
		display: flex;
		flex-direction: column;
		padding: $gap2 $gap5;
		text-decoration: none;
		transition:
			background-color $transition,
			color $transition;

		&:hover {
			background-color: rgba(0, 0, 0, 0.05);

			:global(> *) {
				transform: translateX($gap2);
			}
		}

		:global(> *) {
			transition: transform $transition;
		}
	}

	.link {
		flex: 0 0 auto;
		display: flex;
		justify-content: end;
		align-items: end;
		width: 100%;

		@include sm {
			padding: $gap4 $gap5;
		}
	}
</style>
